module.exports = __webpack_public_path__ + "static/Boogy_Brut_WEB-Book-b8d605f7b2c2da59fcbe445a71ff4fa9.woff2";